import { AsyncActions } from './operator-locks.actions';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const emergencyItemsFeatureKey = 'emergencyItems';

// tslint:disable-next-line:no-empty-interface
export interface OperatorLocksState extends AsyncActionState {} // todo

const initialState: OperatorLocksState = {
    ...asyncActionState.initial,
};

const { loadActions, successActions, errorActions } = AsyncActions;

export const operatorLocksReducer = withLoadables<OperatorLocksState>({
    loadActions,
    successActions,
    errorActions,
})(initialState);
